// extracted by mini-css-extract-plugin
export default {"toast":"Toast_style__toast___f8","simple-box":"Toast_style__simple-box___ca"};